import { render, staticRenderFns } from "./MbaApplicationPage.vue?vue&type=template&id=01e9b338&scoped=true"
import script from "./MbaApplicationPage.vue?vue&type=script&lang=js"
export * from "./MbaApplicationPage.vue?vue&type=script&lang=js"
import style0 from "./MbaApplicationPage.vue?vue&type=style&index=0&id=01e9b338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9b338",
  null
  
)

export default component.exports